import React from 'react';
import './VideoSection.css';

const VideoSection: React.FC = () => {
  return (
    <div className="video-section">
      <div className="video-container">
        {/* 简化的视频区域，只显示背景视频/图片 (Simplified video section, only display background video/image) */}
        <div className="video-placeholder">
          <video 
            className="background-video" 
            autoPlay 
            muted 
            loop 
            playsInline
            poster="https://cdn.glistar.ai/loginpage/video.webp"
            onError={(e) => {
              // 如果视频加载失败，隐藏视频元素，显示回退背景 (Hide video element and show fallback background if video fails to load)
              const target = e.target as HTMLVideoElement;
              target.style.display = 'none';
              const fallback = target.parentElement?.querySelector('.video-fallback') as HTMLElement;
              if (fallback) {
                fallback.style.display = 'block';
              }
            }}
          >
            <source src="https://cdn.glistar.ai/loginpage/video.mp4" type="video/mp4" />
          </video>
          
          {/* 如果视频加载失败，显示背景图片 (Show background image if video fails to load) */}
          <div className="video-fallback"></div>
        </div>
      </div>
    </div>
  );
};

export default VideoSection;
